import React, { Component } from "react";

import {
  Row,
  Col,
  Input,
  Form,
} from "antd";

const { TextArea } = Input;

class SecProfileInformation extends Component {
  state = {
    detailForm: null,
    preLoadOnsubmit: false,
    loadingFullpage: true,
  };

  render() {
    const { match, loginProfile, propFormInput, isViewOnly } = this.props;
    const {} = this.state;

    return (
      <div style={{ width:"100%" }}>
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
        >
          <Col xs={24} md={24} className="mt-2">
          <Form.Item label={"สาเหตุการขอยกเว้น"} style={{ marginBottom: "0px" }}
          rules={[
            { max:255, message: "จำนวนตัวอักษรเกินกำหนด(255)" }
          ]}>
              {propFormInput.getFieldDecorator("remark", {
                //initialValue: this.props.detailProfile.empCode,
              })(<TextArea disabled={isViewOnly}  style={{ width:"100%" }} />)}
            </Form.Item>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SecProfileInformation